import { View, StyleSheet } from 'react-native';

type Variant = 'default' | 'subtle';

interface BackgroundBlobsProps {
  variant?: Variant;
}

export default function BackgroundBlobs({ variant = 'default' }: BackgroundBlobsProps) {
  const opacity = variant === 'subtle' ? 0.5 : 1;

  return (
    <View style={styles.container} pointerEvents="none">
      <View style={[styles.blobTopRight, { opacity }]} />
      <View style={[styles.blobBottomLeft, { opacity }]} />
      <View style={[styles.blobMiddle, { opacity }]} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  blobTopRight: {
    position: 'absolute',
    top: -60,
    right: -60,
    width: 200,
    height: 200,
    borderRadius: 100,
    backgroundColor: 'rgba(108,92,231,0.08)',
  },
  blobBottomLeft: {
    position: 'absolute',
    bottom: -40,
    left: -40,
    width: 160,
    height: 160,
    borderRadius: 80,
    backgroundColor: 'rgba(168,85,247,0.06)',
  },
  blobMiddle: {
    position: 'absolute',
    top: '40%',
    right: '20%',
    width: 120,
    height: 120,
    borderRadius: 60,
    backgroundColor: 'rgba(255,100,150,0.04)',
  },
});
